import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clientResetPassword } from "../slice/clientAuth";
import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";
import { toast } from "react-toastify";

const ClientResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.clientAuth.loading);


    const handleReset = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) return toast.error("Passwords do not match");

        try {
            const res = await dispatch(clientResetPassword({ token, newPassword: password })).unwrap();
            toast.success(res, {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });
            navigate("/signin");
        } catch (err) {
            toast.error(err, {
                position: "top-right",
                autoClose: 2000,
                style: { fontSize: "0.85rem" },
            });
        }
    };

    return (
        <>
            <ClientHeader />
            <main className="overflow-hidden">
                <section className="homepad-signin">  
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 left-panel-signin"
                                style={{
                                    backgroundImage: "url('/assets/images/login-left.jpg')",
                                    backgroundRepeat: "no-repeat"
                                }}>
                                <div className="left-overlay-signin">
                                    <h2 className="montserrat font-weight-bold lh-1 font-size-60">Welcome, <span className="text-yellow">Parents</span> & <span className="text-yellow">Caregivers</span></h2>
                                    <div className="">
                                        <p className="m-0 font-size-14 lh-base">You are your child’s most powerful advocate—and you don’t have to navigate this journey alone. At The Just Generation Foundation, we’re here to help you recognize your child’s unique needs early and connect with trusted professionals who can guide you forward. Whether you're facing speech delays, behavioral concerns, or just a gut feeling that something isn’t quite right, our tools, referrals, and support resources are designed with you in mind. Because every child deserves the best start—and every parent deserves the right support. <br />
                                                        🔵 Explore our screening tools, service providers, and family resources today.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 bg-white d-flex align-items-center">
                                <div className="login-form w-100">
                                    <div className="logo text-center mb-4">
                                        <img src="/assets/images/logo-login.png" className="img-fluid" />
                                    </div>
                                    <h3 className="font-weight-bold montserrat text-primary font-size-34 mb-3 lh-1 text-center">Reset Your Password</h3>
                                    <p className="text-center text-dark">Lorem Ipsum is simply dummy text of the printing!</p>
                                    <form onSubmit={handleReset} className="mt-3 mt-xl-4 pt-xl-2 d-block">
                                        <div className="mb-3">
                                            <label className="form-label text-primary mb-1 font-weight-semibold">New Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label text-primary mb-1 font-weight-semibold">Confirm Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-yellow w-100 mb-3 font-weight-bold font-size-18" disabled={loading}>
                                        {loading ? "Resetting..." : "Reset Password"}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <ClientFooter />
            </main>
        </>
    );
};

export default ClientResetPassword;
